module.exports = __webpack_public_path__ + "img/robot-delivery-engineer-bg.9c13e241.png";